import { Space } from "antd";
import { StyledDropdown } from "./styles";

const DropdownV2 = ({ pr, pl, menuItems = [], content = "DropdownV2", onSelect, ...props }) => {
  
  const onItemSelect = (info) => {
    if (onSelect) {
      onSelect(info); 
    }
  };

  return (
    <>
      <StyledDropdown pl={pl} pr={pr} menu={{ items: menuItems,onClick:onItemSelect }} {...props}>
        <Space>{content}</Space>
      </StyledDropdown>
    </>
  );
};

export default DropdownV2;
